import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AzureCosmosDbV2Dataset } from 'app/model/dataset/azure-cosmos-db.v2.dataset';
import { HierarchicalNode } from 'app/model/dataset/hierarchicalnode';
import { parseJsonSchema } from './json.dataset.adapter';
import { ConnectionKind } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureCosmosDbV2Dataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            structure: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            schema: '*',
            typeProperties: {
                collectionName: '*',
                database: __IS_FABRIC_DPE__ ? '*' : undefined
            }
        }
    }
})
export class AzureCosmosV2DatasetAdapter extends TabularTypeDatasetAdapter<AzureCosmosDbV2Dataset, Model.DatasetResource> {
    public parseHierarchicalSchema(obj: unknown): HierarchicalNode {
        try {
            return parseJsonSchema(obj, 'schema');
        } catch {
            return undefined;
        }
    }

    protected override async _toResource(dataset: AzureCosmosDbV2Dataset): Promise<Model.DatasetResource> {
        const modelDatasetResource = (await super._toResource(dataset)) as Model.DatasetResource;
        const modelDataset = this.properties(modelDatasetResource) as Model.DocumentDbCollectionDataset;
        modelDataset.type = Metamodel.modelFor(AzureCosmosDbV2Dataset).name;
        modelDataset.typeProperties = {
            collectionName: ValueAdapter.toResource(dataset, AzureCosmosDbV2Dataset.TABLE_NAME)
        };
        modelDataset.schema = dataset.rawHierarchicalSchema ? dataset.rawHierarchicalSchema : {};
        if (
            (__IS_FABRIC_DPE__ && dataset.linkedService.tridentConnectionKind === ConnectionKind.AZURE_COSMOS_DB_NOSQL_V2)
                || this.context.adapterConfig.convertToFabric
        ) {
            modelDataset.typeProperties.database = ValueAdapter.toResource(dataset, AzureCosmosDbV2Dataset.DATABASE);
        }
        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected override async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: AzureCosmosDbV2Dataset
    ): Promise<AzureCosmosDbV2Dataset> {
        if (!dataset) {
            dataset = AzureCosmosDbV2Dataset.MODEL.create<AzureCosmosDbV2Dataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        const model = modelDatasetResource.properties as Model.DocumentDbCollectionDataset;
        if (model) {
            if (model.typeProperties) {
                ValueAdapter.toModel(dataset, AzureCosmosDbV2Dataset.TABLE_NAME, model.typeProperties.collectionName);
                ValueAdapter.toModel(dataset, AzureCosmosDbV2Dataset.DATABASE, model.typeProperties.database);
            }
        }

        dataset.rawHierarchicalSchema = modelDatasetResource.properties.schema;
        if (dataset.rawHierarchicalSchema != null) {
            dataset.schemas = this.parseHierarchicalSchema(dataset.rawHierarchicalSchema);
        }

        dataset.raw = JSON.stringify(
            await ValueAdapter.remainder(this.context, modelDatasetResource, AzureCosmosDbV2Dataset.MODEL)
        );
        dataset.isV2 = true;
        return dataset;
    }
}
